import translate from '@allesauto/i18n';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export function useEmission(
  wltEmission: null | number,
  co2Emission: null | number
) {
  const intl = useIntl();

  return useMemo(() => {
    const emissionValue = wltEmission !== null ? wltEmission : co2Emission;

    if (emissionValue === null) {
      return translate(intl, 'ui.COMMON.NOT_AVAILABLE');
    }

    return translate(intl, 'ui.PDP.ENVIRONMENT.CO2_EMMISIONS', {
      value: emissionValue!,
    });
  }, [wltEmission, co2Emission, intl]);
}
